module.exports = "/assets/9d70a1061a110c65e94d46c1d744a7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/B2.png
// module id = 2344
// module chunks = 0